export default "__VITE_ASSET__CToivy6p__"